const setFooterData = (response = {}) => {
    const { payload = {}, status = {} } = response;
    const { success = false } = status;
    return { payload, resSuccess: success };
};

export default setFooterData;
